// extracted by mini-css-extract-plugin
export default {"login":"Login_login__li2fj","loginForm":"Login_loginForm__JhVfY","noAccount":"Login_noAccount__slXe1","googleButton":"Login_googleButton__mcseI"};